export default __webpack_public_path__ + "static/media/mrenan.aa587b30.JPG";